import { render, staticRenderFns } from "./EventsRegister.vue?vue&type=template&id=1dc25d2e&"
import script from "./EventsRegister.vue?vue&type=script&lang=js&"
export * from "./EventsRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports